/*@flow*/
import {
  ContactTypes,
  RecurrenceTemplate,
  EventCategory,
  SelectTemplate,
  CreatableSelectTemplate,
  AssetType,
  AssetSubtype,
  AddressTemplate,
  TheGeomTemplate,
  IssueCategory,
  IssueSubcategory,
  LocationPickerTemplate,
  PhotoUploaderTemplate,
  TenantCategory,
  TenantSubcategory,
  OrganizationCategory,
  OrganizationSubcategory,
  UnitCategory,
  UnitSubcategory,
  UnitTags,
  AddHoursTemplate,
  TextEditorTemplate,
  DocumentUploaderTemplate,
  BuildingCategory,
  PropertyCategory,
  // Statuses
  StreetscapeAssetStatus,
  StreetscapeIssueStatus,
  TenantStatus,
  OrganizationStatus,
  DevelopmentStatus,
  UnitStatus,
  AttractionStatus,
  EventStatus,
  ListingStatus,
  ContactStatus,
  BuildingStatus,
  PropertyStatus,
  TenantBuilding,
  TenantUnits,
  // Contacts
  Contacts,
} from 'lib/templates';
import proformaTemplates from 'lib/proforma/templates';

const templates = {
  ContactTypes,
  RecurrenceTemplate,
  EventCategory,
  SelectTemplate,
  CreatableSelectTemplate,
  AssetType,
  AssetSubtype,
  AddressTemplate,
  TheGeomTemplate,
  IssueCategory,
  IssueSubcategory,
  LocationPickerTemplate,
  PhotoUploaderTemplate,
  TenantCategory,
  OrganizationCategory,
  OrganizationSubcategory,
  UnitCategory,
  UnitSubcategory,
  UnitTags,
  TenantSubcategory,
  AddHoursTemplate,
  TextEditorTemplate,
  DocumentUploaderTemplate,
  BuildingCategory,
  PropertyCategory,
  // Statuses
  StreetscapeAssetStatus,
  StreetscapeIssueStatus,
  TenantStatus,
  OrganizationStatus,
  DevelopmentStatus,
  UnitStatus,
  AttractionStatus,
  EventStatus,
  ListingStatus,
  ContactStatus,
  BuildingStatus,
  PropertyStatus,
  // Associated resources
  TenantBuilding,
  TenantUnits,
  Contacts,
};
proformaTemplates.registry.load(templates);
